
const About = () => {
  return (
    <main className="about">
      <div className="pg-header">
        <div className="container">
          <h1>About</h1>
        </div>
      </div>
      <div className="container content">
        <div className="row">
          <div className="col-lg-4">
            <h2>Why Choose Us.</h2>
            <p>World Wrestling Entertainment, Inc., d/b/a as WWE, is an American professional wrestling promotion. A global integrated media and entertainment company, WWE has also branched out into other fields, including film, American football, and various other business ventures. The company is additionally involved in licensing its intellectual property to companies to produce video games and action figures..</p>
          </div> 
          <div className="col-lg-4">
            <h2>Our Mission.</h2>
            <p>The promotion was founded in 1953 as the Capitol Wrestling Corporation. It is the largest wrestling promotion in the world with its main roster divided up into two primary touring groups, along with a developmental roster based in Orlando, Florida (referred to by WWE as "brands"). Overall, WWE is available in more than 1 billion homes worldwide in 30 languages. The company's global headquarters is located in Stamford, Connecticut,[8] with offices in New York, Los Angeles, Mexico City, Mumbai, Shanghai, Singapore, Dubai and Munich.[9].</p>
          </div>
          <div className="col-lg-4">
            <h2>What We Do.</h2>
            <p>As in other professional wrestling promotions, WWE shows are not legitimate contests but entertainment-based performance theater, featuring story line-driven, scripted, and partially-choreographed matches; however, matches often include moves that can put performers at risk of injury, even death, if not performed correctly. The pre-determined aspect of professional wrestling was publicly acknowledged by WWE's owner Vince McMahon in 1989 in order to avoid taxes from athletic commissions. WWE brands its product as sports entertainment, acknowledging wrestling's roots in competitive sport and dramatic theater..</p>
          </div>
        </div>
      </div>
    </main>
  )
}

export default About